import React, { useRef, useEffect, useState } from 'react';
import { KTexts } from '../contexts/Lang1K';

import Product1KOutline from './Product1K-outline';
import Product1KSpecial from './Product1K-special';
import Product1KFunction from './Product1K-function';
import Product1KCertification from './Product1K-certification';

function Product1K({ lang = 'ko' }) {
  const certRef = useRef(null);
  const [certVisible, setCertVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([entry]) => setCertVisible(entry.isIntersecting),
      { threshold: 0.3 }
    );
    if (certRef.current) observer.observe(certRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#29225C',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',         // 추가: 가로폭 100%
        maxWidth: '100vw',     // 추가: 최대 가로폭 제한
        overflowX: 'hidden',   // 추가: 가로 스크롤 방지
        padding: isMobile ? '0 10px' : '0'  // 모바일에서 좌우 패딩 추가
      }}
    >
      <h1 style={{
        color: '#fff',
        fontSize: isMobile ? '2rem' : '2.5rem',
        fontWeight: 700,
        letterSpacing: '-1px',
        margin: 0,
        marginBottom: isMobile ? 30 : 40,
        textAlign: 'center', // 가운데 정렬 추가
        padding: isMobile ? '0 20px' : '0',
        lineHeight: isMobile ? 1.3 : 1.2
      }}>
        {!isMobile && <><br /><br /><br /></>}{KTexts.title[lang]}
        <br /><span style={{ color: '#ffb300' }}>{KTexts.subtitle[lang]}</span>
      </h1>
      <Product1KOutline lang={lang} isMobile={isMobile}/>
      <Product1KSpecial lang={lang} isMobile={isMobile}/>
      <Product1KFunction lang={lang} isMobile={isMobile}/>
      <Product1KCertification certRef={certRef} certVisible={certVisible} lang={lang} isMobile={isMobile} />
    </div>
  );
}

export default Product1K;